document.addEventListener("DOMContentLoaded", function () {
  const sampleButtonCart = document.querySelectorAll(
    ".section__add_to_cart__sample-v4"
  );

  // Enhanced cart count update function
  function updateCartCount() {
    return fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart data');
        }
        return response.json();
      })
      .then(cart => {
        // Update cart count elements
        const cartCountElements = document.querySelectorAll('.js-cart-count, [data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Update cart icon states
        const cartIconElements = document.querySelectorAll('.js-cart-full, [data-cart-icon]');
        cartIconElements.forEach(element => {
          if (cart.item_count > 0) {
            element.classList.add('js-cart-full');
            element.setAttribute('data-cart-full', 'true');
          } else {
            element.classList.remove('js-cart-full');
            element.setAttribute('data-cart-full', 'false');
          }
        });

        // Trigger custom cart update event
        window.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart, source: 'sample' } 
        }));

        return cart;
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
        throw error;
      });
  }

  // Enhanced notification system (matching calculator v4)
  function showNotification(message, type = 'success') {
    // Remove existing notifications
    const existingNotifications = document.querySelectorAll('.calculator-v4-notification');
    existingNotifications.forEach(notification => {
      notification.remove();
    });

    const notification = document.createElement('div');
    notification.className = `calculator-v4-notification calculator-v4-notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? 'var(--calc-color-success, #00BD10)' : 'var(--calc-color-error, #dc3545)'};
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      font-family: var(--calc-font-family, "Montserrat", sans-serif);
      font-size: 12px;
      font-weight: 500;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      animation: calc-slideInRight 0.3s ease;
      max-width: 300px;
      word-wrap: break-word;
      pointer-events: none;
    `;

    document.body.appendChild(notification);

    // Auto remove after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'calc-slideOutRight 0.3s ease forwards';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 300);
    }, 3000);
  }

  function handleAddSampleToCart(event) {
    event.preventDefault();

    const button = this.querySelector(".get-sample-form-btn-cls-v4");
    if (!button) return;

    const product_id = button.dataset.id;
    const product_qty = parseInt(button.dataset.quantity) || 1;
    const sprice = button.dataset.sprice || '$2.99';

    // Validate required data
    if (!product_id) {
      showNotification('Sample product not available', 'error');
      return;
    }

    toggleAddToCartButton(this, true, sprice);

    const formData = {
      items: [
        {
          id: product_id,
          quantity: product_qty,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        toggleAddToCartButton(this, false, sprice, true);
        return updateCartCount();
      })
      .then(() => {
        showNotification(`Sample added to cart - ${sprice}`, 'success');
      })
      .catch((error) => {
        console.error("Error adding sample to cart:", error);
        toggleAddToCartButton(this, false, sprice, false);
        showNotification('Failed to add sample to cart', 'error');
      });
  }

  function toggleAddToCartButton(element, isLoading = false, samplePrice = "$2.99", success = false) {
    const addToCartButton = element.querySelector(".get-sample-form-btn-cls-v4");
    const buttonText = addToCartButton.querySelector(".button-text");
    const loader = addToCartButton.querySelector(".loader");

    if (!addToCartButton || !buttonText) return;

    if (isLoading) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('loading');
      addToCartButton.classList.remove('success');
      buttonText.textContent = "ADDING TO CART...";
      
      // Hide legacy loader span if it exists
      if (loader) {
        loader.style.display = "none";
      }
    } else {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('loading');
      
      // Hide legacy loader span if it exists
      if (loader) {
        loader.style.display = "none";
      }

      if (success) {
        addToCartButton.classList.add('success');
        buttonText.textContent = "ADDED TO CART";

        // Reset button after 3 seconds
        setTimeout(() => {
          addToCartButton.classList.remove('success');
          buttonText.textContent = `TRY A SAMPLE FOR - ${samplePrice}`;
        }, 3000);
      } else {
        addToCartButton.classList.remove('success');
        buttonText.textContent = `TRY A SAMPLE FOR - ${samplePrice}`;
      }
    }
  }

  // Enhanced event handling with debouncing
  let clickTimeout;
  function debouncedAddToCart(event) {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
    }
    
    clickTimeout = setTimeout(() => {
      handleAddSampleToCart.call(this, event);
    }, 100);
  }

  // Initialize event listeners
  sampleButtonCart.forEach((sampleBtn) => {
    sampleBtn.addEventListener("click", debouncedAddToCart);
  });

  // Listen for variant changes to update sample pricing
  document.addEventListener('variant:changed', function(event) {
    const sampleButtons = document.querySelectorAll('.get-sample-form-btn-cls-v4');
    sampleButtons.forEach(button => {
      const buttonText = button.querySelector('.button-text');
      if (buttonText && event.detail && event.detail.samplePrice) {
        button.dataset.sprice = event.detail.samplePrice;
        if (!button.classList.contains('success') && !button.disabled) {
          buttonText.textContent = `TRY A SAMPLE FOR - ${event.detail.samplePrice}`;
        }
      }
    });
  });
}); 